'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style"];
import * as React from 'react';
import { useStore } from '@base-ui/utils/store';
import { useRenderElement } from "../../base-ui-copy/utils/useRenderElement.mjs";
import { useAdapterContext } from "../../use-adapter-context/index.mjs";
import { useCalendarGridTimeColumnContext } from "../time-column/CalendarGridTimeColumnContext.mjs";
import { useElementPositionInCollection } from "../../internals/utils/useElementPositionInCollection.mjs";
import { CalendarGridCurrentTimeIndicatorCssVars } from "./CalendarGridCurrentTimeIndicatorCssVars.mjs";
import { mergeDateAndTime } from "../../internals/utils/date-utils.mjs";
import { useEventCalendarStoreContext } from "../../use-event-calendar-store-context/index.mjs";
import { schedulerNowSelectors } from "../../scheduler-selectors/index.mjs";
import { processDate } from "../../process-date/index.mjs";
export const CalendarGridCurrentTimeIndicator = /*#__PURE__*/React.forwardRef(function CalendarGridCurrentTimeIndicator(componentProps, forwardedRef) {
  const adapter = useAdapterContext();
  const elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const {
    start: columnStart,
    end: columnEnd
  } = useCalendarGridTimeColumnContext();
  const store = useEventCalendarStoreContext();
  const now = useStore(store, schedulerNowSelectors.nowUpdatedEveryMinute);
  const nowForColumn = React.useMemo(() => processDate(mergeDateAndTime(adapter, columnStart, now), adapter), [adapter, columnStart, now]);
  const endForCalc = React.useMemo(() => processDate(adapter.addMinutes(nowForColumn.value, 1), adapter), [adapter, nowForColumn]);
  const {
    position
  } = useElementPositionInCollection({
    start: nowForColumn,
    end: endForCalc,
    collectionStart: columnStart,
    collectionEnd: columnEnd
  });
  const isOutOfRange = adapter.isBefore(nowForColumn.value, columnStart) || adapter.isAfter(nowForColumn.value, columnEnd);
  return useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [elementProps, {
      style: {
        [CalendarGridCurrentTimeIndicatorCssVars.yPosition]: `${position * 100}%`
      }
    }],
    enabled: !isOutOfRange
  });
});
if (process.env.NODE_ENV !== "production") CalendarGridCurrentTimeIndicator.displayName = "CalendarGridCurrentTimeIndicator";